/**
 * Single entry point for packaged Nette Forms + LiveForm validation.
 * `live-form-validation` bundles its own `netteForms.js` — do not import
 * a separate `nette-forms` package alongside it (two Nette instances).
 */
import validation from 'live-form-validation';
import { installNaisFormAdapter } from './nette-forms-nais-adapter';

const { LiveForm, Nette } = validation as unknown as { LiveForm: any; Nette: any };

window.Nette = Nette;
window.LiveForm = LiveForm;

LiveForm.setOptions({
    showMessageClassOnParent: 'form-group',
    messageParentClass: false,
    controlErrorClass: 'has-error',
    controlValidClass: 'has-success',
    messageErrorClass: 'help-block text-danger',
    enableHiddenMessageClass: 'show-hidden-error',
    disableLiveValidationClass: 'no-live-validation',
    disableShowValidClass: 'no-show-valid',
    messageTag: 'span',
    messageIdPostfix: '_message',
    messageErrorPrefix: '',
    showAllErrors: true,
    showValid: false,
    wait: false,
    focusScreenOffsetY: false,
});

installNaisFormAdapter(Nette, LiveForm);
Nette.initOnLoad();
